import { createAction } from '@ngrx/store';

export const noAction = createAction('[No Action] No Operation');
